import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 18L11.5 12L20 6V18ZM11 18L2.5 12L11 6V18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "FastRewind"
);
